import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toDateOnlyString } from "../../utils";
import EditSaleForm from "./EditSaleForm";

const EditOtherSaleForm = (props) => {
  const { isRefund, onChange, sale, title } = props;

  const loc = sale?.loc || "";
  const pax = sale?.pax || "";
  const pnr = sale?.pnr || "";
  const serviceDate = dayjs(sale?.serviceDate);

  const onSaleChange = (changes) => {
    onChange({
      ...sale,
      serviceDate: toDateOnlyString(serviceDate),
      ...changes,
    });
  };

  const onServiceDateChange = (serviceDate) => {
    onSaleChange({ serviceDate: toDateOnlyString(serviceDate) });
  };

  const onLocationChange = (event) => {
    const loc = event.target.value;
    onSaleChange({ loc });
  };

  const onPassengerChange = (event) => {
    const pax = event.target.value;
    onSaleChange({ pax });
  };

  const onPnrChange = (event) => {
    const value = event.target.value;
    if (value === "" || /^[0-9A-Za-z-]{0,50}$/u.test(value)) {
      const pnr = value.toUpperCase();
      onSaleChange({ pnr });
    }
  };

  return (
    <EditSaleForm
      isRefund={isRefund}
      onChange={onSaleChange}
      sale={sale}
      subTitle={title}
    >
      <Grid xs={12}>
        <TextField
          autoFocus
          fullWidth
          label="Person's Full Name"
          onChange={onPassengerChange}
          required
          value={pax}
        />
      </Grid>
      <Grid xs={12}>
        <TextField
          fullWidth
          label="Confirmation #"
          onChange={onPnrChange}
          value={pnr}
        />
      </Grid>
      <Grid xs={12}>
        <DatePicker
          format="DD-MMM-YYYY"
          label="Service Date *"
          onChange={onServiceDateChange}
          required
          slotProps={{ textField: { fullWidth: true } }}
          value={serviceDate}
        />
      </Grid>
      <Grid xs={12}>
        <TextField
          fullWidth
          label="Service Location (City, Country)"
          onChange={onLocationChange}
          value={loc}
        />
      </Grid>
    </EditSaleForm>
  );
};

export default EditOtherSaleForm;
